window.Products.Accessory.MakeupBag = function() {
};
window.Products.Accessory.MakeupBag.inherits(window.Products.Accessory.Accessory);

window.Products.Accessory.MakeupBag.id = 45;
window.Products.Accessory.MakeupBag.slug = 'makeup-bag';
window.Products.Accessory.MakeupBag.has_3d = true;
window.Products.Accessory.MakeupBag.dpi = 150;
window.Products.Accessory.MakeupBag.rotate_fit = true;
window.Products.Accessory.MakeupBag.fit_template_all = true;
window.Products.Accessory.MakeupBag.preview_data = {
	texture_width: 1024,
	texture_height: 1024,
	scenes: {
		main: {
			deltax: [76,395],
			deltay: 20,
			originalWidth: 319,
			originalHeight: 484,
			scaleWidth: 502,
			scaleHeight: 761,
			preview_x: [9,512],
			preview_y: 131,
			ratio: 57,
			tools: ['mirror_side', 'fit_center', 'fit_side', 'rotation_assist', 'toggle_bleed'],
            warnings: [
                {x:77, y:57},                
                {x:712, y:57},
                {x:712, y:467},                
                {x:77, y:467},
                
                // middle point warning
                {x:456 , y:433 },
                {x:333 , y:433 },
                {x:333, y:91},
                {x:456, y:91},                
                {x:394, y:91},
                {x:394, y:433},
                {x:425, y:91},
                {x:425, y:433},
                {x:363, y:91},
                {x:363, y:433}
            ]
		}
	}
};

window.Products.Accessory.MakeupBag.prototype.setColor = function(color, modelViewer){
	var materials = modelViewer.object.children[0].material;
	switch(color){
		case 'brass':
			materials[0].color = {r:0.55, g:0.46, b:0.29};
			materials[3].color = {r:0.48, g:0.29, b:0.19};
			materials[4].color = {r:1.00, g:0.60, b:0.40};
			materials[1].color = {r:0.75, g:0.75, b:0.75};
			break;
		case 'nickel':
			materials[0].color = {r:0.52, g:0.52, b:0.52};
			materials[3].color = {r:0.07, g:0.07, b:0.05};
			materials[4].color = {r:0.05, g:0.05, b:0.05};
			materials[1].color = {r:0.01, g:0.01, b:0.01};
			break;
	}
};

window.Products.Accessory.MakeupBag.prototype.togglePull = function(pull, modelViewer) {
	modelViewer.object.children[1].visible = (pull != 'no-pull');
};

window.Products.Accessory.MakeupBag.prototype.set3dProperties = function (modelViewer) {
	var me = this;
	me.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.25;
	modelViewer.object.children[0].material[2].bumpScale = 0.03;
	modelViewer.object.children[0].material[2].color.setHex(16776176);
	modelViewer.ambient_light.intensity = 0.7;
	me.loadEnvMap(function(){
		modelViewer.object.children[0].material[0].envMap = me.envMap;
		modelViewer.object.children[0].material[0].envMap.mapping = THREE.EquirectangularReflectionMapping;
		modelViewer.object.children[0].material[0].reflectivity = 0.5;
		modelViewer.object.children[0].material[0].needsUpdate = true;
		modelViewer.object.children[0].material[0].envMap.needsUpdate = true;
	});

	if(modelViewer.inlab){
		me.togglePull('no-pull', modelViewer);
	}
};

window.Products.Accessory.MakeupBag.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[2].map = modelViewer.texture;
};

window.Products.Accessory.MakeupBag.prototype.setThreeControls = function (controls) {
	controls.minDistance = 2.4;
	controls.maxDistance = 4.2;
};